/* src/app/components/app-header/app-header.component.scss */
a {
  color: #646A6A;
  text-decoration: none;
  cursor: pointer;
}
.small-icon {
  width: 0.5rem;
  height: 0.5rem;
}
/*# sourceMappingURL=app-header.component.css.map */
